import React, { Component } from "react";
import { Redirect, Link } from "react-router-dom";
import { formatTime, formatDate, getData, getWeek, apiUrl } from "../util";
class SemFiles extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      dates: null,
      dateData: null,
      domains: null,
      domainData: null,
      domain: null,
      date: null,
    };
  }
  componentDidMount() {
    const { date, all } = this.props.match.params;
    if (date === "domains" && all) {
      const domain = decodeURIComponent(all);
      getData(`${apiUrl}/getNewSemDomains?domain=${domain}`).then(json => {
        this.setState({
          domainData: json.domainData,
          domain: domain,
        });
      });
      return;
    }
    if (date === "domains") {
      getData(`${apiUrl}/getNewSemDomains`).then(json => {
        this.setState({
          domains: json.domains,
        });
      });
      return;
    }
    if (date === "keywords") {
      getData(`${apiUrl}/getNewKeywords`).then(json => {
        if (all) {
          const keyword = decodeURIComponent(all);
          this.setState({
            keywords: json.keywords,
            keyword,
            keywordData: json.keywords[keyword],
          });
        } else {
          this.setState({
            keywords: json.keywords,
          });
        }
      });
      return;
    }
    getData(`${apiUrl}/getNewSemDates`).then(json => {
      if (date) {
        this.setState({
          dates: json.dates,
          date: date,
          dateData: json.dates[date],
        });
      } else {
        this.setState({
          dates: json.dates,
        });
      }
    });
  }
  makeCSV = e => {
    e.preventDefault();
    const { domainData } = this.state;
    const headerArray = [
      "headline",
      "keyword",
      "Ad Count",
      "Ad %",
      "date",
      "Week #",
      "screenshot",
      "landing page",
      "landing page id",
    ];
    const dataArray = [];
    Object.keys(domainData).forEach(keyword => {
      domainData[keyword].forEach(data => {
        const date = formatDate(data.ctime);
        Object.keys(data.byHeadlines).forEach(headline => {
          const hData = data.byHeadlines[headline];
          dataArray.push(
            `"${encodeURIComponent(
              headline
                .replace(/[\x00-\x1F\x7F-\x9F]/g, "")
                .replace("&amp;", "&")
            )}",${keyword},${hData.count},${hData.percentage},${date},
            ${getWeek(new Date(data.ctime))},${hData.shots[0]},${
              hData.landingPage
            },${data.landingPageId}`
          );
        });
      });
    });
    const content = `${headerArray.join(",")}\n${dataArray.join("\n")}`;
    let csvContent = `data:text/csv;base64,${btoa(unescape(content))}`;
    window.open(encodeURI(csvContent));
  };
  getAllShotsDomain = (e, allShotsId, term) => {
    e.preventDefault();
    getData(`${apiUrl}/getAdShots?id=${allShotsId}`).then(json => {
      this.state.domainData[term].forEach(item => {
        if (item.data.allShotsId === allShotsId) {
          item.data.shots = json.ads.shots.map(s => s.screenshot);
        }
      });

      this.setState({
        domainData: this.state.domainData,
      });
    });
  };
  render() {
    const {
      dates,
      dateData,
      date,
      domain,
      domains,
      domainData,
      keywords,
      keywordData,
      keyword,
    } = this.state;
    const { user } = this.props;
    if (!user) {
      return (
        <Redirect
          to={{ pathname: "/", state: { from: this.props.location } }}
        />
      );
    }
    if (domains && !domainData) {
      const domainsArr = Object.keys(domains);
      domainsArr.sort();
      return (
        <>
          <h1>Companies</h1>
          <p>
            <b>
              <Link to="/sem">List by date</Link>
            </b>{" "}
            &middot;{" "}
            <b>
              <Link to="/sem/keywords">List by keyword</Link>
            </b>
          </p>
          {domainsArr.map(kw => {
            return (
              <p key={kw}>
                <Link to={`/sem/domains/${kw}`}>{kw}</Link>
              </p>
            );
          })}
        </>
      );
    }
    if (domainData) {
      return (
        <>
          <h1>{domain}</h1>
          <p>
            <a href="#" onClick={this.makeCSV}>
              Download CSV of this data
            </a>
          </p>
          <div style={{ marginBottom: "20px" }}>
            {Object.keys(domainData).map(keyword => {
              const key = keyword.replace(/\ /gi, "_");
              return (
                <div>
                  <a href={`#${key}`}>{keyword}</a>
                </div>
              );
            })}
          </div>
          {Object.keys(domainData).map(dom => {
            domainData[dom].forEach(d => {
              d.byHeadlines = {};
              if (d.byHeadlines[d.data.headline]) {
                d.byHeadlines[d.data.headline].shots.push(d.data.shots);
              } else {
                d.byHeadlines[d.data.headline] = {
                  shots: d.data.shots,
                  percentage: d.data.percentage,
                  ctime: d.ctime,
                  id: d.id,
                  count: d.data.size,
                  total: d.data.total,
                  headline: d.data.headline,
                  splitTest: d.data.splitTest,
                  flagSplit: d.data.flagSplit,
                  landingPage: d.data.landingPage,
                };
              }
            });
            domainData[dom].sort((a, b) => (a.ctime >= b.ctime ? -1 : 1));
            const key = dom.replace(/\ /gi, "_");
            let currentCTime;
            let showTime = false;
            return (
              <>
                <span id={key} />
                {domainData[dom].map(d => {
                  const newCTime = formatDate(d.ctime);
                  if (currentCTime !== newCTime) {
                    currentCTime = newCTime;
                    showTime = true;
                  } else {
                    showTime = false;
                  }
                  return (
                    <>
                      {showTime && (
                        <>
                          <p style={{ fontSize: "24px" }}>
                            <b>
                              {dom} &middot; {formatDate(d.ctime)} &middot;
                            </b>{" "}
                            <Link
                              to={`/semss/${d.landingPageId}/${
                                d.ctime
                              }/${encodeURIComponent(d.url)}`}
                            >
                              Landing page
                            </Link>{" "}
                            {d.splitTest ? "🔀" : ""}
                            {d.splitTest && (
                              <span>{d.flagSplit ? "⚠️" : "✅"}</span>
                            )}
                          </p>
                        </>
                      )}
                      {Object.keys(d.byHeadlines).map(headline => {
                        const ss = d.byHeadlines[headline].shots;
                        return (
                          <div style={{ marginLeft: "20px" }}>
                            <p>
                              <b>
                                {headline} &middot;{" "}
                                {d.byHeadlines[headline].count} &middot;{" "}
                                {d.byHeadlines[headline].percentage}%
                              </b>
                            </p>
                            {ss.map(shot => (
                              <>
                                <img src={shot} />
                              </>
                            ))}
                            {d.data.size > 3 && !d.data.gotAllShots && (
                              <p>
                                <a
                                  href="#"
                                  onClick={e => {
                                    this.getAllShotsDomain(
                                      e,
                                      d.data.allShotsId,
                                      dom
                                    );
                                  }}
                                >
                                  Get all ad shots
                                </a>
                              </p>
                            )}
                          </div>
                        );
                      })}
                    </>
                  );
                })}
              </>
            );
          })}
        </>
      );
    }
    if (keywords && !keywordData) {
      return (
        <>
          <h1>Keywords</h1>
          <p>
            <b>
              <Link to="/sem">List by date</Link>
            </b>{" "}
            &middot;{" "}
            <b>
              <Link to="/sem/domains">List by company</Link>
            </b>
          </p>
          {Object.keys(keywords).map(kw => {
            return (
              <p key={kw}>
                <Link to={`/sem/keywords/${kw}`}>{kw}</Link>
              </p>
            );
          })}
        </>
      );
    }
    if (keywordData) {
      keywordData.sort((a, b) => (a.ctime <= b.ctime ? 1 : -1));
      return (
        <>
          <h1>{keyword}</h1>
          {keywordData.map(data => (
            <p key={data.id}>
              <Link to={`/semss/${data.id}/${data.ctime}`}>
                {formatDate(data.ctime)}
              </Link>{" "}
              <br />
              Ran <b>{data.runCount}</b>
            </p>
          ))}
        </>
      );
    }
    if (dates && !dateData) {
      const sortedDates = Object.keys(dates).sort((a, b) => {
        return a <= b ? 1 : -1;
      });
      return (
        <>
          <h1>Files</h1>
          <p>
            <b>
              <Link to="/sem/keywords">List by keyword</Link>
            </b>{" "}
            &middot;{" "}
            <b>
              <Link to="/sem/domains">List by company</Link>
            </b>
          </p>
          {sortedDates.map(date => {
            return (
              <p key={date}>
                <Link to={`/sem/${date}`}>{date}</Link>
              </p>
            );
          })}
        </>
      );
    } else if (dateData) {
      return (
        <>
          <h1>{date}</h1>
          {dateData.map(data => (
            <p key={data.id}>
              <Link to={`/semss/${data.id}/${data.ctime}`}>{data.term}</Link>{" "}
              <br />
              Ran <b>{data.runCount}</b> times at{" "}
              <b>{formatTime(data.ctime)}</b>
            </p>
          ))}
        </>
      );
    } else {
      return <h1>Loading...</h1>;
    }
  }
}

export default SemFiles;
